(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rl-complete-look"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const sizeButton = event.target.closest('.rl-complete-look__size');
    if (sizeButton instanceof HTMLButtonElement && !sizeButton.disabled) {
      const formComponent = sizeButton.closest('product-form-component');
      if (!formComponent) return;

      const variantInput = formComponent.querySelector('input[name="id"]');
      const price = formComponent.querySelector('[data-look-price]');
      const addButton = formComponent.querySelector('[ref="addToCartButton"]');
      const sizeButtons = formComponent.querySelectorAll('.rl-complete-look__size');

      if (!(variantInput instanceof HTMLInputElement) || !(price instanceof HTMLElement) || !(addButton instanceof HTMLButtonElement)) return;

      variantInput.value = sizeButton.dataset.variantId || '';
      price.textContent = sizeButton.dataset.variantPrice || '';
      addButton.disabled = sizeButton.dataset.available !== 'true';

      sizeButtons.forEach((button) => {
        const selected = button === sizeButton;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      return;
    }

    const navButton = event.target.closest('[data-look-prev], [data-look-next]');
    if (!(navButton instanceof HTMLButtonElement)) return;

    const carousel = navButton.closest('.rl-complete-look__carousel');
    const track = carousel?.querySelector('[data-look-track]');
    if (!(track instanceof HTMLElement)) return;

    const firstCard = track.querySelector('.rl-complete-look__card');
    const distance = firstCard instanceof HTMLElement ? firstCard.offsetWidth + 14 : 280;
    track.scrollBy({ left: navButton.hasAttribute('data-look-next') ? distance : -distance, behavior: 'smooth' });
  });

  if (!window.__rlCompleteLookAjaxFallback) {
    window.__rlCompleteLookAjaxFallback = true;

    document.addEventListener('submit', async (event) => {
      const form = event.target instanceof HTMLFormElement
        ? event.target.closest('.rl-complete-look__native-form')
        : null;

      if (!(form instanceof HTMLFormElement) || event.defaultPrevented) return;

      event.preventDefault();

      const variantInput = form.querySelector('input[name="id"]');
      const submitButton = form.querySelector('[ref="addToCartButton"]');
      const addToCartComponent = form.querySelector('add-to-cart-component');
      const variantId = variantInput instanceof HTMLInputElement ? variantInput.value : '';

      if (!variantId || !(submitButton instanceof HTMLButtonElement)) return;

      submitButton.disabled = true;

      const wasAlreadyAnimated = submitButton.dataset.added === 'true';
      if (!wasAlreadyAnimated) {
        addToCartComponent?.animateAddToCart?.();

        const image = addToCartComponent?.dataset.productVariantMedia;
        const cartIcon = document.querySelector('.header-actions__cart-icon');

        if (image && cartIcon) {
          const flyer = document.createElement('fly-to-cart');
          flyer.classList.add('fly-to-cart--main');
          flyer.style.setProperty('background-image', `url(${image})`);
          flyer.style.setProperty('--start-opacity', '0');
          flyer.source = submitButton;
          flyer.destination = cartIcon;
          document.body.appendChild(flyer);
        }
      }

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: ['cart-drawer-section'],
          }),
        });

        if (!response.ok) throw new Error('No se pudo añadir el producto al carrito.');

        const added = await response.json();
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });
        if (!cartResponse.ok) throw new Error('No se pudo actualizar el carrito.');

        const cart = await cartResponse.json();
        const updateEvent = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
        Object.defineProperties(updateEvent, {
          action: { value: 'update' },
          promise: {
            value: Promise.resolve({
              cart: { totalQuantity: cart.item_count },
              detail: {
                action: 'update',
                itemCount: cart.item_count,
                items: cart.items,
                sections: added.sections,
                source: 'rl-complete-look',
                sourceId: form.id || 'rl-complete-look',
                didError: false,
              },
            }),
          },
        });
        document.dispatchEvent(updateEvent);

      } catch (error) {
        const liveRegion = form.querySelector('[ref="liveRegion"]');
        if (liveRegion) liveRegion.textContent = error?.message || 'No se pudo añadir el producto al carrito.';
        submitButton.removeAttribute('data-added');
      } finally {
        submitButton.disabled = false;
      }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
